import UseContext from "../../../hooks/useContext";
import ModalLogout from "./data/modalLogout/ModalLogout";
import ModalAddTeam from "./data/modalTeam/ModalAddTeam";
import ModalEditWorkerPhone from "./data/modalEditWorkerPhone/ModalEditWorkerPhone";
import ModalModifyTeam from "./data/modalTeam/ModalModifyTeam";
import ModalDeleteTeam from "./data/modalTeam/ModalDeleteTeam";
import ModalEditWorkerToken from "./data/modalEditWorkerToken/ModalEditWorkerToken";
import ModalLogTimeSheet from "./data/modalLogTimeSheet/ModalLogTimeSheet";
import ModalSettingsEditBlock from "./data/modalSettings/ModalSettingsEditBlock";
import ModalSendPinSms from "./data/ModalSendPinSms";
import ModalCreateQualificationImport from "./data/ModalCreateQualificationImport";
import ModalEditQualification from "./data/ModalEditQualification";
import ModalDeleteQualification from "./data/ModalDeleteQualification";
import ModalCreateQualificationSimpleSettings from "./data/ModalCreateQualificationSimpleSettings";
import ModalEditSector from "./data/ModalEditSector";
import ModalDeleteSector from "./data/ModalDeleteSector";
import ModalCreateSectorSettings from "./data/ModalCreateSectorSettings";

const dataModal = new Map();
dataModal.set("log_d_logout", <ModalLogout />);
dataModal.set("add_team", <ModalAddTeam />);
dataModal.set("modify_team", <ModalModifyTeam />);
dataModal.set("delete_team", <ModalDeleteTeam />);
dataModal.set("edit_worker_phone", <ModalEditWorkerPhone />);
dataModal.set("edit_worker_token", <ModalEditWorkerToken />);
dataModal.set("log_time_sheet", <ModalLogTimeSheet />);
dataModal.set("settings_edit_block", <ModalSettingsEditBlock />);
dataModal.set("send_pin_sms", <ModalSendPinSms />);
dataModal.set("create_qualification_import", <ModalCreateQualificationImport />);
dataModal.set("edit_qualification", <ModalEditQualification />);
dataModal.set("delete_qualification", <ModalDeleteQualification />);
dataModal.set(
  "create_qualification_simple",
  <ModalCreateQualificationSimpleSettings />
);
dataModal.set("edit_sector", <ModalEditSector />);
dataModal.set("delete_sector", <ModalDeleteSector />);
dataModal.set("create_sector", <ModalCreateSectorSettings />);

const Datamodal = () => {
  const { modalType } = UseContext();
  return <>{dataModal.get(modalType)}</>;
};

export default Datamodal;
